<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        @search="fetchOptionsDebounced"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på kund</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import debounce from 'lodash/debounce';
import apiClient from '@services/ApiClient';

export default {
    name: 'CustomerFilter',
    props: {
        value: null,
    },
    components: {
        VueSelect,
    },
    data() {
        return {
            options: [],
            fetchOptionsDebounced: debounce((search) => {
                this.fetchOptions(search);
            }, 200),
        };
    },
    created() {
        this.fetchOptions(this.$attrs.value);
    },
    beforeUnmount() {
        this.fetchOptionsDebounced.cancel();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async fetchOptions(search = '') {
            await apiClient.get('/vue/customers?per_page=8&search=' + search)
                .then((response) => {
                    this.options = response.data.data.map((item) => ({
                        id: item.CustomerID,
                        label: '#' + item.CustomerID + ' - ' + item.CompanyName,
                    }));
                });
        },
    },
};
</script>
